import clsx from "clsx";
import translate from "../../locales";
import shards from "../../assets/img/shards.png";

export function ShardCard() {
  return (
    <div className={clsx("shards")}>
      <div className="shards__content">
        <img className={clsx("shards__img")} alt="" src={shards} />

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--present",
            "shards__arrow--hide-md",
          )}
          aria-hidden
        >
          <svg
            width="68"
            height="43"
            viewBox="0 0 68 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M66.6817 39.7983C67.2129 39.6473 67.5211 39.0942 67.3701 38.563C67.219 38.0317 66.666 37.7235 66.1347 37.8745L66.4082 38.8364L66.6817 39.7983ZM8.84415 0.78793C8.44954 0.401538 7.81641 0.408204 7.43002 0.802818L1.13341 7.23342C0.747015 7.62804 0.75368 8.26116 1.14829 8.64756C1.54291 9.03395 2.17604 9.02728 2.56243 8.63267L8.15942 2.91658L13.8755 8.51357C14.2701 8.89996 14.9033 8.89329 15.2896 8.49868C15.676 8.10406 15.6694 7.47093 15.2748 7.08454L8.84415 0.78793ZM66.4082 38.8364L66.1347 37.8745C56.6336 40.5758 42.4207 41.9449 30.592 37.4077C24.7003 35.1479 19.4138 31.4296 15.5654 25.6849C11.7149 19.9371 9.25604 12.0889 9.14448 1.49191L8.14453 1.50244L7.14459 1.51297C7.25932 12.4113 9.79248 20.6609 13.9038 26.798C18.0171 32.9382 23.6622 36.8918 29.8757 39.2751C42.2575 44.0243 56.9501 42.5651 66.6817 39.7983L66.4082 38.8364Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--present",
            "shards__arrow--show-md",
          )}
          aria-hidden
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="150"
            height="50"
            viewBox="0 0 150 50"
            fill="none"
          >
            <path
              d="M148.104 49.4233C148.395 49.8926 149.012 50.0371 149.481 49.746C149.951 49.4549 150.095 48.8384 149.804 48.3691L148.954 48.8962L148.104 49.4233ZM0.00375938 29.7187C-0.0440847 30.2689 0.363162 30.7538 0.913371 30.8016L9.87954 31.5813C10.4297 31.6291 10.9146 31.2219 10.9624 30.6717C11.0103 30.1215 10.603 29.6366 10.0528 29.5888L2.08287 28.8958L2.7759 20.9258C2.82375 20.3756 2.4165 19.8908 1.86629 19.843C1.31608 19.7951 0.831266 20.2024 0.783422 20.7526L0.00375938 29.7187ZM148.954 48.8962L149.804 48.3691C139.974 32.5205 120.714 12.5216 94.8258 4.06648C68.8558 -4.41538 36.3847 -1.22376 0.356808 29.0397L1 29.8054L1.64319 30.5711C37.206 0.698281 68.9677 -2.27486 94.2049 5.96765C119.524 14.2368 138.446 33.8516 148.104 49.4233L148.954 48.8962Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--past",
            "shards__arrow--hide-md",
          )}
          aria-hidden
        >
          <svg
            width="25"
            height="85"
            viewBox="0 0 25 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.758065 82.526C0.294192 82.8258 0.161131 83.4448 0.460865 83.9087C0.760599 84.3726 1.37962 84.5056 1.8435 84.2059L1.30078 83.366L0.758065 82.526ZM15.8425 0.993703C15.3364 0.772711 14.7469 1.00387 14.5259 1.51001L10.9247 9.7581C10.7037 10.2642 10.9348 10.8537 11.441 11.0747C11.9471 11.2957 12.5366 11.0645 12.7576 10.5584L15.9587 3.22675L23.2903 6.42788C23.7965 6.64887 24.3859 6.41771 24.6069 5.91157C24.8279 5.40543 24.5967 4.81597 24.0906 4.59497L15.8425 0.993703ZM1.30078 83.366L1.8435 84.2059C14.5104 76.0211 34.6434 48.1336 16.3734 1.54507L15.4424 1.91016L14.5114 2.27524C32.444 48.0033 12.6033 74.8722 0.758065 82.526L1.30078 83.366Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--past",
            "shards__arrow--show-md",
          )}
          aria-hidden
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="130"
            height="39"
            viewBox="0 0 130 39"
            fill="none"
          >
            <path
              d="M1.65933 9.79392C1.24409 9.42978 0.612278 9.47121 0.248142 9.88645C-0.115993 10.3017 -0.0745651 10.9335 0.340674 11.2976L1 10.5458L1.65933 9.79392ZM127.256 0.768625C127.128 0.231359 126.589 -0.100482 126.052 0.0274376L117.296 2.11201C116.759 2.23993 116.427 2.77917 116.555 3.31644C116.683 3.8537 117.222 4.18554 117.76 4.05762L125.542 2.20467L127.395 9.98712C127.523 10.5244 128.062 10.8562 128.599 10.7283C129.137 10.6004 129.469 10.0611 129.341 9.52388L127.256 0.768625ZM1 10.5458L0.340674 11.2976C13.3623 22.7167 35.3229 35.9706 58.9098 38.5355C70.7218 39.82 82.9593 38.4246 94.6709 32.7552C106.384 27.0851 117.506 17.1716 127.135 1.52434L126.283 1.00024L125.432 0.476146C115.97 15.8515 105.117 25.4763 93.7995 30.955C82.4803 36.4344 70.6306 37.7982 59.126 36.5472C36.0797 34.0411 14.4897 21.0452 1.65933 9.79392L1 10.5458Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--others",
            "shards__arrow--hide-md",
          )}
          aria-hidden
        >
          <svg
            width="36"
            height="41"
            viewBox="0 0 36 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M34.3644 2.54035C34.9032 2.41894 35.2415 1.88375 35.1201 1.34497C34.9987 0.806201 34.4635 0.467867 33.9247 0.589285L34.1446 1.56482L34.3644 2.54035ZM9.54178 40.4246C10.0721 40.579 10.6271 40.2743 10.7815 39.744L13.2973 31.1028C13.4517 30.5725 13.147 30.0175 12.6167 29.8631C12.0864 29.7087 11.5314 30.0135 11.377 30.5437L9.14073 38.2248L1.45965 35.9885C0.92938 35.8341 0.37436 36.1388 0.219975 36.6691C0.0655909 37.1994 0.370305 37.7544 0.900572 37.9088L9.54178 40.4246ZM34.1446 1.56482L33.9247 0.589285C27.1314 2.12021 17.671 5.88896 11.4914 12.2972C8.38611 15.5174 6.08149 19.4345 5.40422 24.0864C4.72636 28.7423 5.69458 34.0257 8.94474 39.9457L9.82132 39.4645L10.6979 38.9832C7.6127 33.3637 6.78024 28.517 7.38335 24.3745C7.98706 20.2279 10.0451 16.6782 12.931 13.6855C18.7339 7.6679 27.7705 4.02636 34.3644 2.54035L34.1446 1.56482Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--others",
            "shards__arrow--show-md",
          )}
          aria-hidden
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="162"
            height="81"
            viewBox="0 0 162 81"
            fill="none"
          >
            <path
              d="M159.495 41.8105C159.912 42.1731 160.544 42.1293 160.906 41.7127C161.269 41.2961 161.225 40.6645 160.808 40.3019L160.152 41.0562L159.495 41.8105ZM5.41771 79.8192C5.73872 80.2686 6.36327 80.3727 6.81268 80.0517L14.1363 74.8206C14.5857 74.4995 14.6898 73.875 14.3688 73.4256C14.0478 72.9762 13.4232 72.8721 12.9738 73.1931L6.46394 77.843L1.81402 71.3332C1.49301 70.8837 0.868464 70.7796 0.419052 71.1007C-0.0303597 71.4217 -0.134451 72.0462 0.186559 72.4956L5.41771 79.8192ZM160.152 41.0562L160.808 40.3019C139.276 21.5612 105.585 0.850198 74.6273 0.0254673C59.0931 -0.388367 44.2243 4.20727 31.9869 16.5713C19.7752 28.9092 10.2756 48.8901 5.24505 79.0736L6.23145 79.238L7.21784 79.4024C12.2099 49.4497 21.5923 29.9165 33.4083 17.9782C45.1986 6.06597 59.5031 1.62327 74.574 2.02476C104.826 2.83068 138.073 23.1649 159.495 41.8105L160.152 41.0562Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--legal",
            "shards__arrow--hide-md",
          )}
          aria-hidden
        >
          <svg
            width="25"
            height="57"
            viewBox="0 0 25 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.02313 0.762594C1.51097 0.555928 0.928244 0.80358 0.721578 1.31574C0.514912 1.8279 0.762564 2.41062 1.27472 2.61729L1.64893 1.68994L2.02313 0.762594ZM14.2872 55.7764C14.4795 56.2941 15.0551 56.5579 15.5728 56.3656L24.0096 53.2319C24.5273 53.0396 24.7911 52.4641 24.5989 51.9463C24.4065 51.4286 23.831 51.1648 23.3132 51.3571L15.8138 54.1426L13.0283 46.6432C12.836 46.1255 12.2604 45.8617 11.7427 46.054C11.225 46.2463 10.9612 46.8219 11.1535 47.3396L14.2872 55.7764ZM1.64893 1.68994L1.27472 2.61729C6.44438 4.70334 13.3565 9.82439 17.1532 18.3729C20.9329 26.8831 21.6862 38.9301 14.3155 55.0116L15.2246 55.4282L16.1337 55.8449C23.6965 39.3441 23.0357 26.6904 18.981 17.5611C14.9434 8.47029 7.60095 3.01335 2.02313 0.762594L1.64893 1.68994Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div
          className={clsx(
            "shards__arrow",
            "shards__arrow--legal",
            "shards__arrow--show-md",
          )}
          aria-hidden
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="116"
            height="92"
            viewBox="0 0 116 92"
            fill="none"
          >
            <path
              d="M2.0052 1.00878C2.01005 0.456512 1.56628 0.0048852 1.01402 3.85046e-05C0.461755 -0.00480819 0.0101284 0.438961 0.00528169 0.991224L1.00524 1L2.0052 1.00878ZM115.318 74.0612C115.471 73.5306 115.165 72.9763 114.634 72.8231L105.987 70.3277C105.456 70.1745 104.902 70.4806 104.749 71.0112C104.596 71.5418 104.902 72.0961 105.432 72.2493L113.119 74.4675L110.901 82.1538C110.747 82.6844 111.053 83.2387 111.584 83.3918C112.115 83.545 112.669 83.239 112.822 82.7083L115.318 74.0612ZM1.00524 1L0.00528169 0.991224C-0.194447 23.7496 5.24096 54.9038 22.4243 74.0346C31.0505 83.6384 42.6316 90.2015 57.8699 91.1287C73.0765 92.0539 91.8319 87.3618 114.84 74.6594L114.357 73.7839L113.873 72.9085C91.0636 85.5015 72.6912 90.0267 57.9914 89.1323C43.3232 88.2399 32.2191 81.9465 23.9122 72.6981C7.22927 54.1244 1.80702 23.5912 2.0052 1.00878L1.00524 1Z"
              fill="#EEF7EE"
            />
          </svg>
        </div>

        <div className={clsx("shards__info", "shards__info--present")}>
          <p className={clsx("shards__subtitle")}>
            {translate("info-sources.shards.present.title")}
          </p>
          <p className={clsx("shards__description")}>
            {translate("info-sources.shards.present.description")}
          </p>
        </div>
        <div className={clsx("shards__info", "shards__info--past")}>
          <p className={clsx("shards__subtitle")}>
            {translate("info-sources.shards.past.title")}
          </p>
          <p className={clsx("shards__description")}>
            {translate("info-sources.shards.past.description")}
          </p>
        </div>
        <div className={clsx("shards__info", "shards__info--others")}>
          <p className={clsx("shards__subtitle")}>
            {translate("info-sources.shards.others.title")}
          </p>
          <p className={clsx("shards__description")}>
            {translate("info-sources.shards.others.description")}
          </p>
        </div>
        <div className={clsx("shards__info", "shards__info--legal")}>
          <p className={clsx("shards__subtitle")}>
            {translate("info-sources.shards.legal.title")}
          </p>
          <p className={clsx("shards__description")}>
            {translate("info-sources.shards.legal.description")}
          </p>
        </div>
      </div>
    </div>
  );
}
